// Optional Sentry initialization. Set VITE_SENTRY_DSN to enable.
export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
  if (!dsn) return;
  
  try {
    // Use string concatenation to avoid Vite static analysis
    const sentryPackage = '@sentry' + '/browser';
    import(sentryPackage).then((Sentry: any) => {
      Sentry.init({ dsn });
      console.log('Sentry initialized');
    }).catch(() => {
      console.log('Sentry not available - skipping initialization');
    });
  } catch {
    // ignore
  }
}

export async function addBreadcrumb(category: string, message: string, data?: Record<string, any>) {
  try {
    // Use string concatenation to avoid Vite static analysis
    const sentryPackage = '@sentry' + '/browser';
    const Sentry = await import(sentryPackage);
    Sentry.addBreadcrumb({ category, message, data });
  } catch {
    // ignore when not configured
  }
}
